import { Helmet } from "react-helmet-async";
import { useLang } from "@/i18n/LanguageContext";
import { site } from "@/config/site";

interface Props {
  title: string;
  description: string;
  path?: string;
  jsonLd?: object;
}

export const SEO = ({ title, description, path = "/", jsonLd }: Props) => {
  const { lang } = useLang();
  const url = site.url + path;
  return (
    <Helmet>
      <html lang={lang} />
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content="website" />
      <meta property="og:locale" content={lang === "de" ? "de_AT" : "en_US"} />
      <meta name="twitter:card" content="summary_large_image" />
      <link rel="alternate" hrefLang="de-AT" href={url} />
      <link rel="alternate" hrefLang="x-default" href={url} />
      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
};